import React from 'react';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import IconButton from '../../../../Button/IconButton';
import Title from '../../../../Popup/_partials/DialogCardLayout/Title';
import BasicUserAvatar from '../../../../User/_partials/BasicUserAvatar';
import s from './SelectedGroupHeader.scss';
var SelectedGroupHeader = function (_a) {
    var group = _a.group, resetSelectedGroup = _a.resetSelectedGroup;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(IconButton, { className: s['icon-button'], onClick: resetSelectedGroup },
            React.createElement(ArrowLeft, null)),
        React.createElement(BasicUserAvatar, { className: s['avatar'], user: group, size: 28 }),
        React.createElement(Title, { value: group.username, isConcise: true })));
};
SelectedGroupHeader.displayName = 'SelectedGroupHeader';
export default SelectedGroupHeader;
//# sourceMappingURL=SelectedGroupHeader.js.map